import { useState } from "react";
import { ApproveRejectActions } from "./ApproveRejectActions";
import { RejectWithReasonActions } from "./RejectWithReasonActions";

interface FlaggedContentActionsProps {
  contentType: "post" | "comment";
  i18nRoot: string;
  isApproving: boolean;
  isRejecting: boolean;
  onApprove: () => void;
  onReject: (reason: string | null) => void;
  status: string | null;
}

export const FlaggedContentActions = ({
  contentType,
  status,
  i18nRoot,
  isApproving,
  isRejecting,
  onApprove,
  onReject,
}: FlaggedContentActionsProps) => {
  // When opening a review that is approved, the only possible action is to
  // reject, so we can show the second step of the rejection flow right away.
  const [isRejectWithReason, setIsRejectWithReason] = useState(
    status === "approved",
  );
  return (
    <div className="border-t px-8 py-6">
      {isRejectWithReason ? (
        <RejectWithReasonActions
          i18nRoot={i18nRoot}
          isRejecting={isRejecting}
          onReject={onReject}
          contentType={contentType}
        />
      ) : (
        <ApproveRejectActions
          i18nRoot={i18nRoot}
          isApproving={isApproving}
          onApprove={onApprove}
          onReject={() => setIsRejectWithReason(true)}
          status={status}
          contentType={contentType}
        />
      )}
    </div>
  );
};
